import {Drawer, IconButton} from "@mui/material";
import {useCallback, useEffect, useMemo, useState} from "react";
import {ConfirmGenerationWidget} from "../widgets/ConfirmGenerationWidget";
import {useAppDispatch, useAppSelector} from "../app/store/hooks";
import {setPaymentOpen} from "../app/store/slices/appSlice";
import {clearInitialPhoto, setSelectedPreset} from "../app/store/slices/generationSlice";
import {selectInitialPhoto} from "../app/store/selectors/intialPhotoSelector.ts";
import {InputFeature} from "./InputFeature";
import {selectTextPrompt} from "../app/store/selectors/textPromtSlector.ts";
import {useStartGeneration} from "../entities/hooks/useStartGeneration.ts";
import {useUserInfoUpdate} from "../entities/hooks/useUserInfoUpdate.ts";
import CloseIcon from "@mui/icons-material/Close";


export const StartGenerationDrawer = () => {

    const dispatch = useAppDispatch();
    const selectedPreset = useAppSelector((state) => state.generation.selectedPreset);
    const initialPhotoInput = useAppSelector(selectInitialPhoto)
    const textPromptInput = useAppSelector(selectTextPrompt)
    const userBalance = useAppSelector((state) => state.user.user?.balance ?? 0);
    const {startGeneration} = useStartGeneration();
    const updateUserInfo = useUserInfoUpdate();
    const [isOpen, setIsOpen] = useState(false);


    useEffect(() => {
        setIsOpen(!!selectedPreset)
    }, [selectedPreset]);

    const handleClose = () => {
        dispatch(setSelectedPreset(null));
    };


    const handleGenerateClick = useCallback(async () => {
        if (!selectedPreset) return;

        if (userBalance >= selectedPreset.price) {
            await startGeneration(selectedPreset.id)
            await updateUserInfo()
        } else {
            dispatch(setSelectedPreset(null));
            dispatch(setPaymentOpen(true));
        }
    }, [selectedPreset, userBalance, dispatch, startGeneration, updateUserInfo])

    const handleChangePhoto = useCallback(() => {
        dispatch(clearInitialPhoto());
    }, [dispatch])

    const handleChangeEffect = useCallback(() => {
        dispatch(setSelectedPreset(null));
    }, [dispatch])


    const content = useMemo(() => {
        if (!selectedPreset || !initialPhotoInput) return null;

        if (!initialPhotoInput.value) {
            return (
                <InputFeature input={initialPhotoInput}/>
            )
        }

        return (
            <ConfirmGenerationWidget
                uploadedPhotoSrc={initialPhotoInput?.value || ''}
                effect={selectedPreset}
                onGenerateClick={handleGenerateClick}
                onChangePhoto={handleChangePhoto}
                onChangeEffect={handleChangeEffect}
                textPromptInput={textPromptInput}

            />

        )

    }, [initialPhotoInput, selectedPreset, textPromptInput, handleGenerateClick, handleChangePhoto, handleChangeEffect])

    return (

        <Drawer anchor="bottom" open={isOpen} onClose={handleClose}>
            <IconButton onClick={handleClose} sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                WebkitBackdropFilter: 'none',
                backdropFilter: 'none',
                opacity: 0.7,
            }}>
                <CloseIcon/>
            </IconButton>
            {content}
        </Drawer>
    )
};
